module.exports = __webpack_public_path__ + "img/Gambetti_SX.21075758.png";